import { axiosDS } from '@pp/axios'
import { SimpleResponse } from 'Types/simpleResponse'
import { RequestParams, ResponseCatalog } from 'Models'
import {
	ArchiveBrokerOrder,
	ContactDetails,
	OrderRefusalStatuses,
	OrderStatus,
} from 'Pages/archiveBroker'
import { urls } from 'Constants/Urls'

export const archiveBrokerApi = {
	getAll: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<ArchiveBrokerOrder>>(
			urls.archiveBroker.archive,
			{ params }
		)
		return res.data
	},
	getOne: async (id: string) => {
		const res = await axiosDS().get<ArchiveBrokerOrder>(urls.archiveBroker.order.replace(':id', id))
		return res.data
	},
	getOrderRefusalStatuses: async () => {
		const res = await axiosDS().get<ResponseCatalog<OrderRefusalStatuses>>(
			urls.archiveBroker.orderRefusalStatuses
		)
		return res.data
	},
	getOrderStatuses: async (params: RequestParams) => {
		const res = await axiosDS().get<ResponseCatalog<OrderStatus>>(urls.archiveBroker.orderStatus, {
			params,
		})
		return res.data
	},
	archiveOrderReport: async (params: RequestParams) => {
		const res = await axiosDS().get<SimpleResponse>(urls.archiveBroker.report, {
			params,
		})
		return res.data
	},
	getContactDetails: async (id: string) => {
		const res = await axiosDS().get<{ contact_details: ContactDetails[] }>(
			urls.archiveBroker.contactDetails.replace(':id', id)
		)
		return res.data
	},
}
